<template>
  <section class="font-roboto">
    <div class="mb-7 text-[26px] font-semibold leading-8">О проекте</div>

    <div
      class="grid grid-cols-1 gap-5 max-md:flex max-md:flex-col-reverse 2xl:grid-cols-2"
    >
      <div class="flex flex-col gap-4">
        <h2
          class="text-[24px] font-medium leading-[130%] max-md:text-center md:text-[36px]"
        >
          НАУЧНО-ОБРАЗОВАТЕЛЬНЫЙ ПОРТАЛ «РОССИЙСКАЯ ИСТОРИЧЕСКАЯ ЭНЦИКЛОПЕДИЯ»
        </h2>
        <div class="w-full 2xl:hidden">
          <div
            class="bg-neutral-100 shadow-sm aspect-[755/500] overflow-hidden rounded-2xl"
          >
            <img
              v-lazy-load
              src="/imgs/about-project-library.png"
              alt="Российская историческая энциклопедия - Библиотека"
              class="size-full min-h-[300px] object-cover object-center lg:min-h-[450px]"
            />
          </div>
        </div>
        <div
          class="flex flex-col gap-4 text-[18px] leading-6 max-md:text-justify"
        >
          <p>
            Российская историческая энциклопедия — это фундаментальная
            верифицированная база данных, объединяющая проверенные знания о
            ключевых вехах развития человечества. Проект создан как надёжный
            ориентир для исследователей, студентов и всех, кто стремится к
            глубокому пониманию глобальных исторических процессов.
          </p>

          <p>
            Платформа предлагает пользователям удобную систему навигации по
            прошлому. Интерактивный каталог позволяет изучать историю через
            призму эпох — от Древнего мира до Новейшего времени. Параллельно с
            этим алфавитный справочник открывает быстрый доступ к тысячам статей
            о выдающихся личностях, поворотных событиях и важнейших терминах.
          </p>

          <p>
            В эпоху избытка информации проект выполняет миссию авторитетного
            источника. Мы помогаем очистить исторические факты от искажений,
            проследить причинно-следственные связи и сформировать объективный,
            научно обоснованный взгляд на историю Отечества и мира.
          </p>
        </div>
      </div>

      <div class="w-full max-2xl:hidden">
        <div
          class="bg-neutral-100 shadow-sm aspect-[755/500] overflow-hidden rounded-2xl"
        >
          <img
            v-lazy-load
            src="/imgs/about-project-library.png"
            alt="Российская историческая энциклопедия - Библиотека"
            class="size-full min-h-[300px] object-cover object-center lg:min-h-[450px]"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
useHead({
  title: 'О проекте | Российская историческая энциклопедия | История РФ',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Научно-образовательный портал «Российская историческая энциклопедия» — верифицированная база знаний о ключевых вехах истории Отечества и мира. Российское военно-историческое общество.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: `${useHostApp()}/encyclopedia/about`,
    },
  ],
});
</script>

<style></style>
